import { InvoiceResponse, PaymentStatus } from '@bonhams1793/bonhams-typescript'
import getConfig from 'next/config'

import { createAuthenticatedAxiosClient } from '@nx/axios-client'
import { BonhamsCookies } from '@nx/global-types'

const { publicRuntimeConfig } = getConfig()

export async function getUserInvoices({
  userId,
  paymentStatus,
  invoiceIds,
  query,
  country,
  accessTokenSSR,
  refreshTokenSSR,
}: GetUserInvoicesProps) {
  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR,
    refreshTokenSSR,
    baseURL: publicRuntimeConfig.WEB_API_URL,
    timeout: 30_000,
  })

  const params: {
    status?: PaymentStatus
    query?: string
    country?: string
  } = {}

  if (paymentStatus) {
    params['status'] = paymentStatus
  }

  if (query) {
    params['query'] = query
  }

  if (country) {
    params['country'] = country
  }

  return await authenticatedAxiosClient
    .get<InvoiceResponse>(
      `/api/clients/${userId}/invoice/${invoiceIds ? `?invoiceIds=${invoiceIds.join('&invoiceIds=')}` : ''}`,
      { params }
    )
    .then((response) => response.data)
}

export interface GetUserInvoicesProps {
  userId: number
  paymentStatus?: PaymentStatus
  invoiceIds?: number[]
  query?: string
  country?: string
  accessTokenSSR?: BonhamsCookies['bonhams_access']
  refreshTokenSSR?: BonhamsCookies['bonhams_token']
}
